function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.48824 0C1.77512 0 0.0012207 1.78157 0.0012207 4.1232C0.0012207 6.41312 1.72227 8.24551 4.38413 8.24551H4.43562C7.20181 8.24551 8.92331 6.41312 8.92331 4.1232C8.8716 1.78157 7.20181 0 4.48824 0Z",
  fill: "#DCFF79"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.469971 11.5034H8.40157V35.366H0.469971V11.5034Z",
  fill: "#DCFF79"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.8701 10.9434C23.5913 10.9434 20.7221 14.964 20.7221 14.964V11.5034H12.7903V35.366H20.7217V22.0402C20.7217 21.3268 20.7734 20.6145 20.9829 20.1044C21.5563 18.6798 22.8612 17.204 25.0524 17.204C27.9225 17.204 29.0704 19.3923 29.0704 22.6003V35.366H37.0013V21.6836C37.0013 14.3541 33.0881 10.9434 27.8701 10.9434Z",
  fill: "#DCFF79"
});

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7fe4159d.svg";
export { ForwardRef as ReactComponent };